import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";

import api from "@/lib/axios";
import { CurrentUser } from "@/types/user";

export function useCurrentUser() {
  const { isAuthenticated } = useAuth0();

  const { data: meta, isLoading } = useQuery({
    queryKey: ["me"],
    enabled: isAuthenticated,
    queryFn: async () => {
      const { data } = await api.get<CurrentUser>("users/me");
      return data;
    },
  });

  return { user: meta as CurrentUser | undefined, isLoading };
}
